import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormControlName } from '@angular/forms';
import { dateOrEmptyValidator } from '../../shared/validators/date-or-empty.validator';
import * as formHelper from '../../shared/helpers/form.helper';
import { BaseComponent } from '../../core/component/base.component';
import * as moment from 'moment';
import { ReportingService, LoadingService } from '../../core/services';
import { RegistrationsBySite } from '../../core/services/models';

@Component({
  selector: 'app-registrations-by-site',
  templateUrl: './registrations-by-site.component.html',
  styleUrls: ['./registrations-by-site.component.scss']
})
export class RegistrationsBySiteComponent extends BaseComponent implements OnInit {

  registrations:Array<RegistrationsBySite> = new Array<RegistrationsBySite>();
  max:Date = new Date();
  min:Date = new Date('January 1, 1900');

  registrationForm = new FormGroup({
    startDate : new FormControl('',Validators.compose([Validators.required,dateOrEmptyValidator])),
    endDate: new FormControl('',Validators.compose([Validators.required,dateOrEmptyValidator]))  
  });

  constructor(private reportingService:ReportingService, private loadingService:LoadingService) { 
    super();
    const originFormControlNameNgOnChanges = FormControlName.prototype.ngOnChanges;
  
    FormControlName.prototype.ngOnChanges = function () {
      let result;
      if (arguments) {
        result = originFormControlNameNgOnChanges.apply(this, arguments);
      }
      if (this.control && this.valueAccessor && this.valueAccessor.element) {
        this.control.nativeElement = this.valueAccessor.element.nativeElement;
      }
      return result;
    };
  }

  ngOnInit() {
    formHelper.markControlAndChildControlsAsDirty(this.registrationForm);
  }

  wrongOrder():boolean {

    const startDate = new Date(this.registrationForm.get('startDate').value);
    const endDate = new Date(this.registrationForm.get('endDate').value);

    return moment(startDate).isAfter(moment(endDate));

  }

  inRange():boolean {
    
    const startDate = new Date(this.registrationForm.get('startDate').value);
    const endDate = new Date(this.registrationForm.get('endDate').value);

    return moment(startDate).isValid() && moment(startDate).isBetween(this.min,this.max) && moment(endDate).isValid() && moment(endDate).isBetween(this.min,this.max);

  }

  minDate():string {
    return moment(this.min).format("MM[/]DD[/]YYYY");
  }

  maxDate():string {
    return moment(this.max).format("MM[/]DD[/]YYYY");
  }

  startDateValueChanged() {
    this.registrationForm.get('startDate').updateValueAndValidity();
  }

  endDateValueChanged() {
    this.registrationForm.get('endDate').updateValueAndValidity();    
  }

  lookupRegistrations() {
    
    if(this.registrationForm.valid && !this.wrongOrder() && this.inRange()) {
      this.loadingService.loading = true;
      const startDate: string = new Date(this.registrationForm.get('startDate').value).toDateString();
      const endDateAfter: Date = new Date(this.registrationForm.get('endDate').value);
      endDateAfter.setDate(endDateAfter.getDate() + 1 );
      const endDate: string = endDateAfter.toDateString();
      this.reportingService.getRegistrationsBySite(startDate,endDate).subscribe((data:Array<RegistrationsBySite>) => {
        this.loadingService.loading = false;
        this.registrations = data;        
      }, error => {
        this.loadingService.loading = false;
        throw(error);
      });
    }
  }

}
